import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE2,
} from "App/constants";
import {
  InputCheckboxMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  titleModal,
} from "App/utils/helpers";

export const RESET_STATE_FORMULA = {
  id: "",
  name: "",
  remark: "-",
  status: 1,
};

export const getAllFormula = async () => {
  try {
    const api = await instance2.get("/formula/listformula");
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteFormulaById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      "/formula/deleteformula",
      {},
      {
        headers: {
          idFormula: id,
        },
      }
    );
    const newData = await fetchData(TYPE_INSTANCE2, "/formula/listformula");
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_FORMULA);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, formData, setFormData, setRows }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addFormula = async () => {
    return instance2.post("/formula/addformula", {
      ...formData,
    });
  };

  const updateFormula = () => {
    return instance2.post(
      "/formula/updateformula",
      {
        ...formData,
      },
      {
        headers: {
          idformula: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addFormula();
        } else if (formData.id !== "") {
          await updateFormula();
        }
        const newData = await fetchData(TYPE_INSTANCE2, "/formula/listformula");
        setRows(newData);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_FORMULA);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`${titleModal(formData.id)} Formula`} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>

          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
